import { render, staticRenderFns } from "./highway-archives.vue?vue&type=template&id=2ab1b71c&scoped=true"
import script from "./highway-archives.vue?vue&type=script&lang=js"
export * from "./highway-archives.vue?vue&type=script&lang=js"
import style0 from "./highway-archives.vue?vue&type=style&index=0&id=2ab1b71c&prod&scoped=scoped&lang=less"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2ab1b71c",
  null
  
)

export default component.exports